module.exports = __webpack_public_path__ + "c20d5f08.webp";